import { useCallback, useEffect } from "react";
import { decodeToken, getToken } from "../utils/authUtils";
import { useDispatch } from "react-redux";
import { setUserDatas } from "../features/userDatasSlice";

export default function useUserDatas({
	t,
	lang,
	setSnackbarMessage,
	setOpenSnackbar,
	setOpenBackdrop,
	navigate,
	handleLogout,
	skipInitialFetch = false,
}) {
	const dispatch = useDispatch();

	const fetchUserDatas = useCallback(async () => {
		try {
			const decodedUser = decodeToken();
			const userId = decodedUser?.id || null;
			const token = getToken();

			if (!userId || !token) {
				handleLogout({
					t,
					lang,
					setSnackbarMessage,
					setOpenSnackbar,
					setOpenBackdrop,
					navigate,
					logoutMessage: t("mapPage.tokenExpired") || "認證失效，請重新登入",
				});
				return;
			}

			const response = await fetch(
				`${process.env.REACT_APP_API_URL}/users/${userId}`,
				{
					method: "GET",
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json",
					},
				}
			);

			if (response.status === 401 || !response.ok) {
				handleLogout({
					t,
					lang,
					setSnackbarMessage,
					setOpenSnackbar,
					setOpenBackdrop,
					navigate,
					logoutMessage: t("mapPage.tokenExpired") || "認證失效，請重新登入",
				});
				return;
			}

			const data = await response.json();

			if (data && typeof data === "object") {
				dispatch(setUserDatas(data));
			}
		} catch (error) {
			handleLogout({
				t,
				lang,
				setSnackbarMessage,
				setOpenSnackbar,
				setOpenBackdrop,
				navigate,
				logoutMessage: t("mapPage.networkError") || "網路錯誤，請重新登入",
			});
		}
	}, [dispatch]);

	useEffect(() => {
		// console.log("skipInitialFetch", skipInitialFetch);
		// console.log("SkipInitialFetch type:", typeof(skipInitialFetch));
		if (!skipInitialFetch) {
			fetchUserDatas();
		}
		
	}, [skipInitialFetch, fetchUserDatas]);

	return { refreshUserDatas: fetchUserDatas };
}
